<canvas #canvas class="drawing-canvas"></canvas>

<button (click)="save()" class="btn btn-success">Save</button>
<button (click)="erase()" class="btn btn-secondary">Clear All</button>
<button (click)="setDrawingTool('eraser')" [disabled]="currentTool === 'eraser'" class="btn btn-error">Eraser</button>
<button (click)="setDrawingTool('pen')" [disabled]="currentTool === 'pen'" class="btn btn-primary">Pen</button>
